import { createSlice } from "@reduxjs/toolkit";
import { getProducts, changeActive, getExtras, changeExtraActive, changeSuggested, menuCentralAdmin, disableMenuItemExtraAdmin, menuExtrasAdmin, importItems, disableMenuItemAdmin, getAdminProducts, getSyncStatus, toggleIgnoreBranchOverridesApi } from "../../api/Products";

export const productsSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    extras: [],
    categories: [],
    currentBranch: null,
    platform: "take_out",
    channels: [],
    suggestedSections: [],
  },
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setChannels: (state, action) => {
      state.channels = action.payload;
    },
    setExtras: (state, action) => {
      state.extras = action.payload;
    },
    setActive: (state, action) => {
      const { product, val, platform, entityType } = action.payload;
      const index = state.products.findIndex((el) => el.id === product);
      if (index > -1) {
        const prod = state.products[index];
        if (entityType === 'channel') {
          if (!prod.channels) prod.channels = [];
          const channelIndex = prod.channels.findIndex(c => c.name.toLowerCase() === platform.toLowerCase());
          if (channelIndex > -1) {
            prod.channels[channelIndex].active = val ? 1 : 0;
          } else {
            prod.channels.push({ name: platform, active: val ? 1 : 0 });
          }
        } else {
          prod[platform] = val;
        }
      }
    },
    updateProductIgnoreOverrides: (state, action) => {
      const { sku, value } = action.payload;
      const index = state.products.findIndex((el) => String(el.sku) === String(sku));
      if (index > -1) {
        state.products[index].ignore_branch_overrides = value;
      }
    },

    setExtraActive: (state, action) => {
      const { extra, val, platform } = action.payload;
      const numVal = Number(val);
      const indexExtra1 = state.extras.extras ? state.extras.extras.findIndex((el) => String(el.id) === String(extra)) : -1;
      const indexExtra2 = state.extras.extras2 ? state.extras.extras2.findIndex((el) => String(el.id) === String(extra)) : -1;
      if (indexExtra1 > -1) state.extras.extras[indexExtra1][platform] = numVal;
      if (indexExtra2 > -1) state.extras.extras2[indexExtra2][platform] = numVal;

    },

    setSuggested: (state, action) => {
      const { product, val, sectionId } = action.payload;
      const index = state.products.findIndex((el) => el.id === product);
      if (index > -1) {
        if (!state.products[index].suggested_sections) {
          state.products[index].suggested_sections = {};
        }
        state.products[index].suggested_sections[sectionId] = val;
      }
    },
    setSuggestedSections: (state, action) => {
      state.suggestedSections = action.payload;
    },
    setCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },
    setPlatform: (state, action) => {
      state.platform = action.payload;
    },
  },

});

// Action creators are generated for each case reducer function
export const { setProducts, setActive, setCategories, setExtras, setSuggested, setSuggestedSections, setExtraActive, setCurrentBranch, setPlatform, updateProductIgnoreOverrides, setChannels } = productsSlice.actions;

export const getAllProducts = (branch) => async (dispatch) => {
  try {
    const response = await getProducts(branch);
    if (!response.error && response.status === 200) {
      const { categories } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      if (response.data.platform) {
        dispatch(setPlatform(response.data.platform));
      }
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const getAllAdminProducts = (branch) => async (dispatch) => {
  try {
    const response = await getAdminProducts(branch);
    if (!response.error && response.status === 200) {
      const { categories, channels, suggested_sections } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      dispatch(setChannels(channels || []));
      dispatch(setSuggestedSections(suggested_sections || []));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleCurrentBranch = (branch) => async (dispatch) => {
  dispatch(setCurrentBranch(branch));
  return branch
};

export const handleActive = (product, active, platform, branch, userId, entityType) => async (dispatch) => {
  try {
    dispatch(setActive({ product, val: !active, platform, branch, userId, entityType }));
    const response = await changeActive(product, !active, platform, branch, userId, entityType);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setActive({ product, val: active, platform, branch, userId, entityType }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setActive({ product, val: active, platform, branch, userId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const getAllExtras = (branch) => async (dispatch) => {
  try {
    const response = await getExtras(branch);
    if (!response.error && response.status === 200) {
      const { extras, extras2 } = response.data;
      //let extras = [];
      //infxtra.forEach((item) => {
      //  extras.push(item);
      //});
      const new_extras = { extras, extras2 };
      dispatch(setExtras(new_extras));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleExtraActive = (extra, active, platform, branch, cat, userId) => async (dispatch) => {
  try {
    const newVal = active ? 0 : 1;
    const oldVal = active ? 1 : 0;
    dispatch(setExtraActive({ extra, val: newVal, platform, branch, cat, userId }));
    const response = await changeExtraActive(extra, newVal, platform, branch, cat, userId);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setExtraActive({ extra, val: oldVal, platform, branch, cat, userId }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setExtraActive({ extra, val: active ? 1 : 0, platform, branch, cat, userId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const handleSection = (product, active, sectionId, userId) => async (dispatch) => {
  try {
    const newVal = active ? 0 : 1;
    const oldVal = active ? 1 : 0;
    dispatch(setSuggested({ product, val: newVal, sectionId }));
    const response = await changeSuggested(product, newVal, sectionId, userId);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    dispatch(setSuggested({ product, val: oldVal, sectionId }));
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    dispatch(setSuggested({ product, val: active ? 1 : 0, sectionId }));
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const menuCentralAdminThunk = (userId) => async (dispatch) => {
  try {
    const response = await menuCentralAdmin(userId);
    if (!response.error && response.status === 200) {
      const { categories, suggested_sections } = response.data;
      let products = [];
      const productCategories = [];
      categories.forEach((category) => {
        products = products.concat(category.products);
        productCategories.push({ text: category.name, value: category.id });
      });
      dispatch(setProducts(products));
      dispatch(setCategories(productCategories));
      dispatch(setSuggestedSections(suggested_sections || []));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}
export const menuExtrasAdminThunk = (userId) => async (dispatch) => {
  try {
    const response = await menuExtrasAdmin(userId);
    if (!response.error && response.status === 200) {
      const { extras, extras2 } = response.data;
      //let extras = [];
      //infxtra.forEach((item) => {
      //  extras.push(item);
      //});
      const new_extras = { extras, extras2 };
      dispatch(setExtras(new_extras));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};
export const disableMenuItemAdminThunk = (userId, sku, mode) => async () => {
  try {
    const response = await disableMenuItemAdmin(userId, sku, mode);
    if (!response.error && response.status === 200) {

      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const disableMenuItemExtraAdminThunk = (userId, sku, mode) => async () => {
  try {
    const response = await disableMenuItemExtraAdmin(userId, sku, mode);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const importItemsThunk = (whatsync, sku) => async () => {
  try {
    const response = await importItems(whatsync, sku);
    if (!response.error && response.status === 200) {
      return {
        status: "success",
        data: response.data
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const getSyncStatusThunk = () => async () => {
  try {
    const response = await getSyncStatus();
    if (!response.error && response.status === 200) {
      return {
        status: "success",
        data: response.data
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const toggleIgnoreBranchOverridesThunk = (userId, sku) => async (dispatch) => {
  try {
    const response = await toggleIgnoreBranchOverridesApi(userId, sku);
    if (!response.error && response.status === 200) {
      dispatch(updateProductIgnoreOverrides({ sku, value: response.data.ignore_branch_overrides }));
      return {
        status: "success",
        ignore_branch_overrides: response.data.ignore_branch_overrides
      };
    }
    return {
      status: "error",
      type: "unknown"
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown"
    };
  }
};

export const selectProducts = (state) => state.products.products;
export const selectCategories = (state) => state.products.categories;
export const selectExtras = (state) => state.products.extras;
export const selectCurrentBranch = (state) => state.products.currentBranch;
export const selectPlatform = (state) => state.products.platform;
export const selectChannels = (state) => state.products.channels;
export const selectSuggestedSections = (state) => state.products.suggestedSections;
export default productsSlice.reducer;